import './styles.scss';

import { Button, Col, Row } from 'react-bootstrap';
import { Dayts, createNotification } from '@/utils';

import { CombineRuleHistory } from '@/models/gen/graphql';
import CombineRuleHistoryItem from './CombineRuleHistoryItem';
import Form from '@/common/Form';
import { LoadingBlur } from '@/components/LoadingSpinner';
import { Toast } from '@/models';
import { createCombineRuleHistoryBulk } from '../../api/services/combineRule/createCombineRuleHistoryBulk';
import { updateCombineRuleHistoryBulk } from '../../api/services/combineRule/updateCombineRuleHistoryBulk';
import { useState } from 'react';

export type CombineDiscountFormProps = {
  value?: { items?: Partial<CombineRuleHistory>[]; airline?: string; combineRuleId?: string };
  onCancel?: () => void;
};

const CombineDiscountForm = ({ value, onCancel }: CombineDiscountFormProps): JSX.Element => {
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const loading = loadingCreate || loadingUpdate;

  const handleAdd = (form): void => {
    let defaultStartDate = new Dayts();
    const items = form.getValues('items') || [];
    items?.forEach((item) => {
      const startDate = new Dayts(item?.startDatetime);
      if (startDate >= defaultStartDate) {
        defaultStartDate = startDate.add(1, 'day');
      }
    });
    form.setValue('items', [...items, { discount: 0, startDatetime: defaultStartDate.format('MMM DD, YYYY') }], {
      shouldValidate: true,
    });
  };

  const handleSubmit = async (data) => {
    try {
      const { combineRuleId } = data || {};
      const creates = data?.items?.filter((item) => !item?.id)?.map((item) => ({ ...item, combineRuleId })) || [];
      const updates = data?.items?.filter((item) => item?.id)?.map((item) => ({ ...item, combineRuleId })) || [];
      if (creates?.length) {
        try {
          setLoadingCreate(true);
          await createCombineRuleHistoryBulk(creates);
          createNotification('Discount successfuly created.', Toast.Type.SUCCESS, 'Create Discount');
        } catch {
          createNotification('Unable to create discount. Please try again.', Toast.Type.DANGER, 'Create Discount');
          throw new Error('Create Combine Discount Failed');
        } finally {
          setLoadingCreate(false);
        }
      }
      if (updates?.length) {
        try {
          await updateCombineRuleHistoryBulk(updates);
          createNotification('Discount successfuly updated.', Toast.Type.SUCCESS, 'Update Discount');
        } catch {
          createNotification('Unable to update discount. Please try again.', Toast.Type.DANGER, 'Update Discount');
          throw new Error('Update Combine Discount Failed');
        } finally {
          setLoadingUpdate(false);
        }
      }
      onCancel && onCancel();
    } catch (err) {}
  };

  return (
    <Form name="CombineDiscountForm" className="CombineDiscountForm" onSubmit={handleSubmit} value={value}>
      <LoadingBlur loading={loading} />
      <Row className="CombineDiscountForm-Header">
        <Col>
          <span>{value?.airline}</span>
          <h4 className="CombineDiscountForm-Title">COMBINE DISCOUNT</h4>
        </Col>
      </Row>
      <div className="CombineDiscountForm-Body">
        <Row>
          <Col>
            <Form.Watch name="items">
              {([items = value?.items]: [Partial<CombineRuleHistory>[]], form) =>
                (items || []).map((combineRuleHistoryItem: CombineRuleHistory, index: number): JSX.Element => {
                  var nextStartDate,
                    endDate = '';
                  if (combineRuleHistoryItem.id && index < items.length - 1) {
                    nextStartDate = new Dayts(items[index + 1]?.startDatetime);
                    endDate = new Dayts(nextStartDate.subtract(1, 'day')).format('MMM DD, YYYY');
                  } else {
                    endDate = '---';
                  }
                  return <CombineRuleHistoryItem data={combineRuleHistoryItem} endDate={endDate} index={index} form={form} key={index} />;
                })
              }
            </Form.Watch>
          </Col>
        </Row>
        <Row>
          <Col>
            <Form.Watch name="items">
              {([items = []]: [CombineRuleHistory[]], form) => (
                <Button name="ADD_DISCOUNT" className="w-100 add-discount-btn" onClick={() => handleAdd(form)}>
                  <i className="fa fa-plus" />
                  ADD DISCOUNT
                </Button>
              )}
            </Form.Watch>
          </Col>
        </Row>
      </div>
      <Row className="CombineDiscountForm-Footer">
        {onCancel && (
          <Col>
            <Button className="w-100" onClick={onCancel} variant="secondary" name="CANCEL">
              Cancel
            </Button>
          </Col>
        )}
        <Col>
          <Form.Button className="w-100" type="submit" variant="primary" name="SAVE">
            SAVE
          </Form.Button>
        </Col>
      </Row>
    </Form>
  );
};
export default CombineDiscountForm;
